export enum MonthlyCalendarRibbonType {
  Trip = 1,
  Leg = 2
}
